import React, { useState } from 'react';
import './CouponCard.css';

const CouponCard = ({
  coupon,
  onEdit,
  onDelete,
  onToggleActive,
  onViewTerms,
  onViewAnalytics
}) => {
  const [copied, setCopied] = useState(false);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  const getStatus = () => {
    const now = new Date();
    const validTill = new Date(coupon.validTill);
    const validFrom = new Date(coupon.validFrom);

    if (!coupon.isActive) {
      if (validFrom > now) return { type: 'scheduled', label: '🕐 Scheduled' };
      return { type: 'expired', label: '✕ Expired' };
    }
    if (validTill < now) return { type: 'expired', label: '✕ Expired' };
    return { type: 'active', label: '● Active' };
  };

  const handleCopyCode = () => {
    navigator.clipboard.writeText(coupon.code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const status = getStatus();
  const remaining = coupon.usageLimit ? coupon.usageLimit - coupon.timesUsed : '∞';
  const usagePercentage = coupon.usageLimit 
    ? (coupon.timesUsed / coupon.usageLimit) * 100 
    : 0;

  return (
    <div className="coupon-card">
      <div className="card-header">
        <div className="coupon-code-section">
          <span className="coupon-icon">🎟️</span>
          <div
            className="coupon-code"
            onClick={handleCopyCode}
            title="Click to copy"
          >
            {coupon.code}
            {copied && <span className="copy-tooltip">Copied!</span>}
          </div>
        </div>
        <div className={`status-badge ${status.type}`}>
          {status.label}
        </div>
      </div>

      <div className="card-body">
        <div className="coupon-description">{coupon.description}</div>

        <div className="coupon-details">
          <div className="detail-item">
            <span className="detail-icon">💰</span>
            <span className="detail-text">
              {coupon.discountType === 'percentage'
                ? `${coupon.discountValue}% OFF`
                : `PKR ${coupon.discountValue} OFF`}
            </span>
          </div>
          {coupon.discountType === 'percentage' && coupon.maxDiscount && (
            <div className="detail-item">
              <span className="detail-icon">📊</span>
              <span className="detail-text">Max: PKR {coupon.maxDiscount}</span>
            </div>
          )}
          {coupon.minOrderAmount && (
            <div className="detail-item">
              <span className="detail-icon">🛒</span>
              <span className="detail-text">Min order: PKR {coupon.minOrderAmount}</span>
            </div>
          )}
        </div>

        <div className="usage-stats" onClick={onViewAnalytics}>
          <div className="stat-item">
            <div className="stat-label">Used</div>
            <div className="stat-number">{coupon.timesUsed}</div>
          </div>
          <div className="stat-item">
            <div className="stat-label">Remaining</div>
            <div className="stat-number">{remaining}</div>
          </div>
          <div className="stat-item">
            <div className="stat-label">Revenue Impact</div>
            <div className="stat-number">PKR {(coupon.revenueImpact / 1000).toFixed(0)}K</div>
          </div>
        </div>

        {coupon.usageLimit && (
          <div className="progress-bar">
            <div
              className="progress-fill"
              style={{ width: `${Math.min(usagePercentage, 100)}%` }}
            />
          </div>
        )}

        <div className="validity-section">
          <span className="validity-icon">📅</span>
          <span className="validity-text">
            {formatDate(coupon.validFrom)} -{' '}
            <span className={status.type === 'expired' ? 'expired-date' : ''}>
              {formatDate(coupon.validTill)}
            </span>
          </span>
        </div>
      </div>

      <div className="card-footer">
        <a href="#" className="terms-link" onClick={(e) => { e.preventDefault(); onViewTerms(); }}>
          T&C
        </a>
        <div className="action-buttons">
          <button className="action-btn edit-btn" onClick={onEdit}>
            ✏️ Edit
          </button>
          <button className="action-btn duplicate-btn" onClick={() => onEdit({ ...coupon, id: null })}>
            📋 Duplicate
          </button>
          <button className="action-btn delete-btn" onClick={onDelete}>
            🗑️ Delete
          </button>
          <label className="toggle-switch">
            <input
              type="checkbox"
              checked={coupon.isActive}
              onChange={onToggleActive}
            />
            <span className="toggle-slider"></span>
          </label>
        </div>
      </div>
    </div>
  );
};

export default CouponCard;

